import * as z from 'zod';
import { GroupTypeSchema } from '../enums/GroupType.schema';

export const GroupSchema = z.object({
  id: z.string(),
  name: z.string(),
  type: GroupTypeSchema,
});

export type GroupType = z.infer<typeof GroupSchema>;
